<!-- <mat-toolbar color="primary">
    <button [fxShow.lt-md]="true" [fxShow]="false"  mat-icon-button (click)="openSidenav()">
        <mat-icon>menu</mat-icon>
    </button>
    <span>Payment Check</span>
</mat-toolbar> -->
<div class="content" fxLayout="column" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="16px" [@routeAnimation]="true">
    <mat-tab-group #tabGroupGrants mat-stretch-tabs>

        <mat-tab label="Chartible Contribution">
            <mat-card>
                <mat-tab-group #tabGroupCC mat-stretch-tabs *ngIf="tabGroupGrants.selectedIndex === 0">
                    <mat-tab label="Validate Invoice">
                        <mat-card>
                            <payment-check-table-component *ngIf="tabGroupCC.selectedIndex === 0" [data]='formCCDetails' [displayedColumns]='columnsFormCC' type='pendingValidate'>
                            </payment-check-table-component>
                        </mat-card>
                    </mat-tab>

                    <mat-tab label="Send Invoice to OeBS">
                        <mat-card>
                            <payment-check-table-component *ngIf="tabGroupCC.selectedIndex === 1" [data]='formCCUploadDetails' [displayedColumns]='columnsFormCC' type='forUpload'>
                            </payment-check-table-component>
                        </mat-card>
                    </mat-tab>

                    <mat-tab label="Invoice Successfully Sent to OeBS">
                        <mat-card>
                            <payment-check-table-component *ngIf="tabGroupCC.selectedIndex === 2" [data]='formCCSentToOeBSDetails' [displayedColumns]='columnsFormCCSentToOEBS' type='sentOeBS'>
                            </payment-check-table-component>
                        </mat-card>
                    </mat-tab>
                </mat-tab-group>
            </mat-card>
        </mat-tab>

        <mat-tab label="Community Grants">
            <mat-card>
                <mat-tab-group #tabGroupCG mat-stretch-tabs *ngIf="tabGroupGrants.selectedIndex === 1">
                    <mat-tab label="Validate Invoice">
                        <mat-card>
                            <payment-check-ext-table-component *ngIf="tabGroupCG.selectedIndex === 0" [data]='formCGDetails' [displayedColumns]='columnsFormCGPP' form='CG' type='pendingValidate'>
                            </payment-check-ext-table-component>
                        </mat-card>
                    </mat-tab>

                    <mat-tab label="Send Invoice to OeBS">
                        <mat-card>
                            <payment-check-ext-table-component *ngIf="tabGroupCG.selectedIndex === 1" [data]='formCGUploadDetails' [displayedColumns]='columnsFormCGPP' form='CG' type='forUpload'>
                            </payment-check-ext-table-component>
                        </mat-card>
                    </mat-tab>

                    <mat-tab label="Invoice Successfully Sent to OeBS">
                        <mat-card>
                            <payment-check-ext-table-component *ngIf="tabGroupCG.selectedIndex === 2" [data]='formCGSentToOeBSDetails' [displayedColumns]='columnsFormCGPPSentToOEBS' form='CG' type='sentOeBS'>
                            </payment-check-ext-table-component>
                        </mat-card>
                    </mat-tab>
                </mat-tab-group>
            </mat-card>
        </mat-tab>

        <mat-tab label="Plant for the Planet">
            <mat-card>
                <mat-tab-group #tabGroupPP mat-stretch-tabs *ngIf="tabGroupGrants.selectedIndex === 2">
                    <mat-tab label="Validate Invoice">
                        <mat-card>
                            <payment-check-ext-table-component *ngIf="tabGroupPP.selectedIndex === 0" [data]='formPPDetails' [displayedColumns]='columnsFormCGPP' form='PP' type='pendingValidate'>
                            </payment-check-ext-table-component>
                        </mat-card>
                    </mat-tab>

                    <mat-tab label="Send Invoice to OeBS">
                        <mat-card>
                            <payment-check-ext-table-component *ngIf="tabGroupPP.selectedIndex === 1" [data]='formPPUploadDetails' [displayedColumns]='columnsFormCGPP' form='PP' type='forUpload'>
                            </payment-check-ext-table-component>
                        </mat-card>
                    </mat-tab>

                    <mat-tab label="Invoice Successfully Sent to OeBS">
                        <mat-card>
                            <payment-check-ext-table-component *ngIf="tabGroupPP.selectedIndex === 2" [data]='formPPSentToOeBSDetails' [displayedColumns]='columnsFormCGPPSentToOEBS' form='PP' type='sentOeBS'>
                            </payment-check-ext-table-component>
                        </mat-card>
                    </mat-tab>
                </mat-tab-group>
            </mat-card>

        </mat-tab>

        <mat-tab label="Event Sponsorship">
            <mat-card>
                <mat-tab-group #tabGroupES mat-stretch-tabs *ngIf="tabGroupGrants.selectedIndex === 3">
                    <mat-tab label="Validate Invoice">
                        <mat-card>
                            <payment-check-ext-table-component *ngIf="tabGroupES.selectedIndex === 0" [data]='formESDetails' [displayedColumns]='columnsFormES' form='ES' type='pendingValidate'>
                            </payment-check-ext-table-component>
                        </mat-card>
                    </mat-tab>

                    <mat-tab label="Send Invoice to OeBS">
                        <mat-card>
                            <payment-check-ext-table-component *ngIf="tabGroupES.selectedIndex === 1" [data]='formESUploadDetails' [displayedColumns]='columnsFormES' form='ES' type='forUpload'>
                            </payment-check-ext-table-component>
                        </mat-card>
                    </mat-tab>

                    <mat-tab label="Invoice Successfully Sent to OeBS">
                        <mat-card>
                            <payment-check-ext-table-component *ngIf="tabGroupES.selectedIndex === 2" [data]='formESSentToOeBSDetails' [displayedColumns]='columnsFormESSentToOEBS' form='ES' type='sentOeBS'>
                            </payment-check-ext-table-component>
                        </mat-card>
                    </mat-tab>
                </mat-tab-group>
            </mat-card>
        </mat-tab>

    </mat-tab-group>
</div>





<!-- <mat-tab label="Community Investment Funding">
    <mat-card>
        <mat-tab-group #tabGroupCI mat-stretch-tabs *ngIf="tabGroupGrants.selectedIndex === 3">
            <mat-tab label="Validate Invoice">
                <mat-card>
                    <payment-check-ext-table-component *ngIf="tabGroupCI.selectedIndex === 0" [data]='formCIDetails'
                        [displayedColumns]='displayedColumnsExt' form='CI' type='pendingValidate'>
                    </payment-check-ext-table-component>
                </mat-card>
            </mat-tab>

            <mat-tab label="Send Invoice to OeBS">
                <mat-card>
                    <payment-check-ext-table-component *ngIf="tabGroupCI.selectedIndex === 1"
                        [data]='formCIUploadDetails' [displayedColumns]='displayedColumnsExt' form='CI'
                        type='forUpload'>
                    </payment-check-ext-table-component>
                </mat-card>
            </mat-tab>

            <mat-tab label="Invoice Successfully Sent to OeBS">
                <mat-card>
                    <payment-check-ext-table-component *ngIf="tabGroupCI.selectedIndex === 2"
                        [data]='formCISentToOeBSDetails' [displayedColumns]='displayedColumnsExtCR' form='CI'
                        type='sentOeBS'>
                    </payment-check-ext-table-component>
                </mat-card>
            </mat-tab>
        </mat-tab-group>
    </mat-card>
</mat-tab> -->